
import React from "react";
import { Outlet } from "react-router-dom";
import { PageHeader } from "./PageHeader";
import { PendingDeletionReactivationBanner } from "@/components/auth/PendingDeletionReactivationBanner";

export const MainContent: React.FC = () => {
  return (
    <div className="main-content">
      <PendingDeletionReactivationBanner />
      <div className="page-content-surface">
        <div className="page-header-surface">
          <PageHeader />
        </div>
        <div className="page-body-surface" data-onboarding-scroll-lock-root>
          <Outlet />
        </div>
      </div>
    </div>
  );
};
